import { ElementRef } from '@angular/core';
import { ViewChild } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { TemplateRef } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { untilDestroyed } from '@ngneat/until-destroy';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-closeable-container',
  templateUrl: './closeable-container.component.html',
})
export class CloseableContainerComponent implements AfterViewInit {

  @Input() readonly open: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  @Input() readonly contentTemplate: TemplateRef<any>;
  @Input() readonly scrollIntoViewOnOpen: boolean = false;

  @Output() readonly closed = new EventEmitter<void>();

  @ViewChild('container')
  private container: ElementRef<HTMLDivElement>;

  ngAfterViewInit(): void {

    if (this.scrollIntoViewOnOpen) {

      this.open
        .pipe(
          untilDestroyed(this),
          distinctUntilChanged(),
          filter(x => !!x),
        )
        .subscribe(() => setTimeout(() => this.scrollIntoView()));
    }
  }

  close(): void {
    this.closed.emit();
  }

  private scrollIntoView(): void {

    if (this.container) {
      this.container.nativeElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

}
